import styled from "styled-components";

const QuickSecondtNewServiceWrapper = styled.div`
  .p-datatable .p-datatable-tbody > tr > td {
    border: 1px solid #dee2e6;
    border-width: 0 0 1px 0;
    padding: .8rem;
    font-size:11px;
  }

  .action-btn {
    border-radius: 10px;
    opacity: 1;
    border: none;
    color: white;
    &.submit-btn {
      background: var(--main-color);
    }
    &.back-btn {
      background: white;
      border: 1px solid var(--main-color);
      color: var(--main-color);
    }
  }
  .exit-btn {
    margin: auto auto 0 auto;
    width: fit-content;
    border: 1px solid #286c4d;
    border-radius: 10px;
    background: #e5ede9;
    color: #286c4d;
  }
`;

export default QuickSecondtNewServiceWrapper;
